/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer__Auctions__Item_4Inputs */

const en_footer__auctions__item_4 = /** @type {(inputs: Footer__Auctions__Item_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bid packages`)
};

/**
* | output |
* | --- |
* | "Bid packages" |
*
* @param {Footer__Auctions__Item_4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const footer__auctions__item_4 = /** @type {((inputs?: Footer__Auctions__Item_4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer__Auctions__Item_4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_footer__auctions__item_4(inputs)
});